/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { BaseController } from '../../BaseController';

class ExportsBoardController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log, $translate,
        exportsService, domainService, siteService, equipmentService, filterService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.exportsService = exportsService;
        this.domainService = domainService;
        this.siteService = siteService;
        this.equipmentService = equipmentService;
        this.filterService = filterService;
        this.$translate = $translate;
        this.$log.debug('Controller \'ExportsBoard\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.exports = [];
        this.downloadExport = {
            status: 'NONE',
            id: ''
        };
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {

        this.exportsFilter = Filter.equalFilter('export', this.exports, 'ui.exports.exporttype', 'SELECT',
                'SELECT', [{
                id: 'ACTION_REQUESTS_BY_CAUSE',
                labelKey: 'ui.exports.export.ACTION_REQUESTS_BY_CAUSE'
            },{
                id: 'ACTION_REQUESTS_BY_SYMPTOM',
                labelKey: 'ui.exports.export.ACTION_REQUESTS_BY_SYMPTOM'
            },{
                id: 'ACTION_REQUESTS_CANCELED_BY_SYMPTOM',
                labelKey: 'ui.exports.export.ACTION_REQUESTS_CANCELED_BY_SYMPTOM'
            },{
                id: 'STATE_AFTER_INTERVENTION',
                labelKey: 'ui.exports.export.STATE_AFTER_INTERVENTION'
            },{
                id: 'SYMPTOM_CAUSE',
                labelKey: 'ui.exports.export.SYMPTOM_CAUSE'
            },{
                id: 'INTERVENTION_TIME',
                labelKey: 'ui.exports.export.INTERVENTION_TIME'
            },{
                id: 'INTERVENTION_LIST',
                labelKey: 'ui.exports.export.INTERVENTION_LIST'
            },{
                id: 'PROG_MES_LIST',
                labelKey: 'ui.exports.export.PROG_MES_LIST'
            }]);

        this.siteFilter = Filter.equalFilterEmpty('equipment.site.id', 'model.site.site', 'SELECT_AUTOCOMPLETE', []);

        this.domainFilter = Filter.equalFilterEmpty('equipment.site.domain.id', 'model.domain.domain', 'SELECT',
            [], domainId => this.getFilterSites(domainId));

        const startDate = new Date();
        startDate.setUTCMonth(0, 1);
        startDate.setHours(0, 0, 0, 0);
        this.startDateFilter = Filter.greaterOrEqualDateTimeFilter('resolutionDate', startDate,
            'ui.statistics.from', undefined, false, true);

        const endDate = new Date();
        endDate.setHours(23, 59, 59);
        this.endDateFilter = Filter.lowerDateTimeFilter('resolutionDate', endDate,
            'ui.statistics.before');

        this.filters = [
            this.exportsFilter,
            this.domainFilter,
            this.siteFilter,
            this.startDateFilter,
            this.endDateFilter
        ];
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        // No command in the view.
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterDomains()
            .then(() => this.getFilterSites(this.domainFilter.value));
    }

    /**
     * Gets the list of domains.
     *
     * @return {Object[]} Promise providing an array of domains.
     */
    getFilterDomains() {
        return this.filterService.getFilterOptions(this.domainService, this.domainFilter, 'name');
    }

    /**
     * Gets the list of sites for a given domain.
     *
     * @param {Number} [domainId] Domain ID, may be undefined if no domain is selected.
     * @return {Object[]} Promise providing an array of sites.
     */
    getFilterSites(domainId) {
        return this.filterService.getOrClearFilterOptions(this.siteService, this.siteFilter, 'name',
            [Filter.equalFilter('domain.id', domainId)], domainId)
    }

    /**
     * Gets the exports.
     *
     * @return {Promise} A promise providing the content of the csv, or a rejection if no type of export was selected.
     */
    getExports() {
        this.downloadExport.status = 'NONE';
        let promise;
        if (!this.exportsFilter.value.length > 0) {
            promise = false;
        } else {
            // Removes the 'export' filter from the filters that are sent in the request.
            const requestFilters = this.filterService.buildFilters(this.filters);
            const exportFilterIndex = requestFilters.findIndex(filter => filter.key === 'export');
            if (exportFilterIndex >= 0) {
                requestFilters.splice(exportFilterIndex, 1);
            }
            promise = this.exportsService.generateExports(this.exportsFilter.value, requestFilters);
            promise.then(file => {
                this.downloadExport.id = file.id;
                this.downloadExport.status = 'PENDING';
                this.checkExportStatus(file.id);
            });
        }
        return promise;
    }

    /**
     * Check every n seconds the status of the export
     * @param fileId
     */
    checkExportStatus(fileId) {
        clearInterval(this.checkExportInterval);
        this.checkExportInterval = setInterval(() => {
            this.exportsService.getExportsStatus(fileId).then(exportStatus => {
                if (exportStatus.status === 'AVAILABLE') {
                    clearInterval(this.checkExportInterval);
                    this.downloadExport.status = 'AVAILABLE'
                } else if (exportStatus.status === 'ERROR') {
                    clearInterval(this.checkExportInterval);
                    this.downloadExport.status = 'ERROR'
                }
            })
        }, 3000);
    }
}

export const exportsBoardComponent = {
    template: require('./exports-board.html'),
    controller: ExportsBoardController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/exports/component/ExportsBoard.js